import { createContext, useContext, ReactNode } from "react";

import RadioCardOption from "./RadioCardOption";

import * as styles from "./RadioCard.styles";

interface RadioCardContextValue {
  name: string;
  selectedValue: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: string) => void;
  disabled?: boolean;
}

const RadioCardContext = createContext<RadioCardContextValue | undefined>(undefined);

export const useRadioCardContext = () => {
  const context = useContext(RadioCardContext);
  if (!context) {
    throw new Error("RadioCardOption must be used within a RadioCard");
  }
  return context;
};

interface RadioCardProps {
  id: string;
  name: string;
  value: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: string) => void;
  disabled?: boolean;
  children: ReactNode;
  label?: string;
}

function RadioCard({
  id,
  name,
  value,
  onChange,
  disabled = false,
  children,
  label
}: RadioCardProps) {
  const contextValue: RadioCardContextValue = {
    name,
    selectedValue: value,
    onChange,
    disabled
  };

  return (
    <RadioCardContext.Provider value={contextValue}>
      <div
        id={id}
        role="radiogroup"
        css={styles.radioCard}
        aria-label={label || name}>
        {children}
      </div>
    </RadioCardContext.Provider>
  );
}

RadioCard.displayName = "RadioCard";

RadioCard.Option = RadioCardOption;

export default RadioCard;
